module.exports = __webpack_public_path__ + "static/media/bell.2e57fbe0.svg";